import { useState } from 'react';

function ImageSearch({ searchTerm }) {
  const [typedValue, setTypedValue] = useState('');

  const handlChange = function (event) {
    setTypedValue(event.target.value);
  };

  const handleSubmit = function (event) {
    event.preventDefault();

    searchTerm(typedValue);
  };

  return (
    <div className="max-w-sm rounded overflow-hidden my-10 mx-auto">
      <form className="w-full max-w-sm" onSubmit={handleSubmit}>
        <div className="flex items-center border-b border-b-2 border-blue-600 py-2">
          <input
            className="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 py-1 px-2 leading-tight focus:outline-none"
            type="text"
            placeholder="Cars, bike, Computer, etc...."
            onChange={handlChange}
          />
          <button
            className="flex-shrink-0 bg-blue-600 hover:bg-teal-700 border-blue-600 hover:border-teal-700 text-sm border-4 text-white py-1 px-2 rounded transition-all"
            type="submit"
          >
            Search
          </button>
        </div>
      </form>
    </div>
  );
}

export default ImageSearch;
